import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';

import { BaseService } from '../services/base.service';

@Injectable()
export class HomeAuthGuard extends BaseService implements CanActivate {
  constructor(protected http: Http, private router: Router) {
    super(http);
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      const isAuth = await this.get('checkToken');
      return true;
    }
    catch (err) {
      this.router.navigate(['/login'], { queryParams: { redirectTo: state.url }});
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home-auth-guard.service.ts